import React, { useState, useEffect } from 'react';
import { useStateValue } from '../StateProvider.js';
import axios from 'axios';
import configData from '../Config.json';
import Title from '../Title.js';

import { permissionResources, getHomePermission } from '../Utils/permissions.js';

import '../Settings.css';

function Menu({ state, setState }) {
    const [{ project }, dispatch] = useStateValue();

    const homepermission = getHomePermission(project.projectuserid, project.users, state.user.userid);

    const [menu, setMenu] = useState({});

    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const handleToggle = (permission) => {
        setMenu(prev => ({
            ...prev,
            [permission]: !prev[permission]
        }));
    };

    const handleSave = () => {
        console.log('Trying to update menu');

        setResult('');

        setLoading(true);

        const data = {
            projectuserid: project.projectuserid,
            projectid: project.projectid,
            userid: state.user.userid,
            menu: menu
        }

        axios.post(configData.CONTROLLERURL + configData.UPDATEMENU, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            }
        }).then((res) => {
            console.log('Update menu data received')
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    dispatch({
                        type: 'UPDATE_MENU',
                        menu: menu
                    });
                }
                else {
                    setResult(res.data.data)
                }
            }
            else {
                setResult('Error');
            }
        }).catch((err) => {
            setResult(err.response?.data?.message || err.message || 'Network error');
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <div className='settings_menu'>
            <Title text='Menu' />

            <div className='buttonscontainer'>
                <button className='button' onClick={handleSave}>Save</button>
            </div>
            <div>{JSON.stringify(menu)}</div>
            <table className='table'>
                <thead><tr><th></th><th>Menu</th><th></th></tr></thead>
                <tbody>
                    {
                        permissionResources.map((permission, index) => (
                            <tr key={'permission' + index}>
                                <td><div>{permission}</div></td>
                                <td>
                                    <div>
                                        <input
                                            className='checkbox'
                                            type="checkbox"
                                            checked={menu[permission] || false}
                                            onChange={() => handleToggle(permission)}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}

export default Menu;